/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6.5 15 6.5 15M6 12C6 8.68629 8.66667 6 12 6C16 6 17.5 9 17.5 9M17.5 9V6.5M17.5 9H15M6.5 15H9M6.5 15V17.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M6 12C6 15.3137 8.68629 18 12 18C15.3137 18 17.5 15 17.5 15M18 12C18 8.68629 15.3333 6 12 6C8 6 6.5 9 6.5 9M6.5 9V6.5M6.5 9H9M17.5 15H15M17.5 15V17.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM12 5.25C8.25085 5.25 5.25 8.27368 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75C6.41421 12.75 6.75 12.4142 6.75 12C6.75 9.0989 9.08248 6.75 12 6.75C13.794 6.75 15.0009 7.41714 15.7619 8.06944C15.8324 8.12983 15.8991 8.19019 15.9622 8.25H15C14.5858 8.25 14.25 8.58579 14.25 9C14.25 9.41421 14.5858 9.75 15 9.75H17.5C17.9142 9.75 18.25 9.41421 18.25 9V6.5C18.25 6.08579 17.9142 5.75 17.5 5.75C17.0858 5.75 16.75 6.08579 16.75 6.5V6.94079L16.7381 6.93056C15.7491 6.08286 14.206 5.25 12 5.25ZM18.75 12C18.75 11.5858 18.4142 11.25 18 11.25C17.5858 11.25 17.25 11.5858 17.25 12C17.25 14.8995 14.8995 17.25 12 17.25C10.573 17.25 9.3576 16.6026 8.46886 15.9088C8.40094 15.8558 8.33525 15.8027 8.27187 15.75H9C9.41421 15.75 9.75 15.4142 9.75 15C9.75 14.5858 9.41421 14.25 9 14.25H6.5C6.08579 14.25 5.75 14.5858 5.75 15V17.5C5.75 17.9142 6.08579 18.25 6.5 18.25C6.91421 18.25 7.25 17.9142 7.25 17.5V16.8506C7.3441 16.9303 7.44276 17.0107 7.54586 17.0912C8.57869 17.8974 10.1133 18.75 12 18.75C15.7279 18.75 18.75 15.7279 18.75 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6.5 15 6.5 15M6 12C6 8.68629 8.66667 6 12 6C16 6 17.5 9 17.5 9M17.5 9V6.5M17.5 9H15M6.5 15H9M6.5 15V17.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6.5 15 6.5 15M6 12C6 8.68629 8.66667 6 12 6C16 6 17.5 9 17.5 9M17.5 9V6.5M17.5 9H15M6.5 15H9M6.5 15V17.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.25 12C5.25 8.27368 8.25085 5.25 12 5.25C14.206 5.25 15.7491 6.08286 16.7381 6.93056C16.7421 6.93397 16.746 6.93738 16.75 6.94079V6.5C16.75 6.08579 17.0858 5.75 17.5 5.75C17.9142 5.75 18.25 6.08579 18.25 6.5V9C18.25 9.41421 17.9142 9.75 17.5 9.75H15C14.5858 9.75 14.25 9.41421 14.25 9C14.25 8.58579 14.5858 8.25 15 8.25H15.9622C15.8991 8.19019 15.8324 8.12983 15.7619 8.06944C15.0009 7.41714 13.794 6.75 12 6.75C9.08248 6.75 6.75 9.0989 6.75 12C6.75 12.4142 6.41421 12.75 6 12.75C5.58579 12.75 5.25 12.4142 5.25 12ZM18 11.25C18.4142 11.25 18.75 11.5858 18.75 12C18.75 15.7279 15.7279 18.75 12 18.75C10.1133 18.75 8.57869 17.8974 7.54586 17.0912C7.44276 17.0107 7.3441 16.9303 7.25 16.8506V17.5C7.25 17.9142 6.91421 18.25 6.5 18.25C6.08579 18.25 5.75 17.9142 5.75 17.5V15C5.75 14.5858 6.08579 14.25 6.5 14.25H9C9.41421 14.25 9.75 14.5858 9.75 15C9.75 15.4142 9.41421 15.75 9 15.75H8.27187C8.33525 15.8027 8.40094 15.8558 8.46886 15.9088C9.3576 16.6026 10.573 17.25 12 17.25C14.8995 17.25 17.25 14.8995 17.25 12C17.25 11.5858 17.5858 11.25 18 11.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
